import { logger } from '@/services/logger';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';
const R2_PUBLIC_URL = import.meta.env.VITE_R2_PUBLIC_URL ?? '';
const STREAM_CHAT_API_KEY = import.meta.env.VITE_STREAM_CHAT_API_KEY ?? '';
// TODO(dev1/TEST-DROPS): test-only past-dated deck, remove before release
const IS_TEST_DROPS = import.meta.env.VITE_TEST_DROPS?.toLowerCase() === 'true';

const REQUIRED_ENV: Record<string, string> = {
  VITE_SUPABASE_URL: SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: SUPABASE_ANON_KEY,
  VITE_API_BASE_URL: API_BASE_URL,
  VITE_R2_PUBLIC_URL: R2_PUBLIC_URL,
};

const missingEnv = Object.keys(REQUIRED_ENV).filter(key => !REQUIRED_ENV[key]);

if (missingEnv.length > 0) {
  logger.error(`environment is incomplete: ${missingEnv.join(', ')}`);
}

export {
  API_BASE_URL,
  IS_TEST_DROPS,
  R2_PUBLIC_URL,
  STREAM_CHAT_API_KEY,
  SUPABASE_ANON_KEY,
  SUPABASE_URL,
  missingEnv,
};
